import { Controllers } from 'lib/enums/routes/_controllers';
import { CustodiansRoutes } from 'lib/enums/routes/custodians';
import {
  CustodianDoc,
  CustodianWhole,
} from 'lib/interfaces/database/custodian';
import { BaseService } from 'services/_base';

export class CustodiansService extends BaseService {
  private static instance: CustodiansService;

  static getInstance(): CustodiansService {
    if (!CustodiansService.instance) {
      CustodiansService.instance = new CustodiansService();
    }

    return CustodiansService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.custodians,
    });
  }

  search(payload: Partial<CustodianDoc>) {
    return this.POST(
      {
        uri: CustodiansRoutes.Search,
      },
      payload
    )
      .then((result: CustodianWhole[]) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  create(payload: Partial<CustodianDoc>) {
    return this.POST(
      {
        uri: CustodiansRoutes.CreateOne,
      },
      payload
    )
      .then((result: CustodianWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  update(id: string, payload: Partial<CustodianDoc>) {
    return this.PUT(
      {
        uri: `${CustodiansRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((result: CustodianWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
